import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress PostHog/Analytics cross-origin errors (from Emergent platform)
const originalError = console.error;
console.error = (...args) => {
  if (args[0]?.includes?.('posthog') || 
      args[0]?.includes?.('cross-origin') ||
      args[0]?.includes?.('removeEventListener')) {
    return; // Suppress these errors
  }
  originalError.apply(console, args);
};

// Global error handler to suppress analytics errors
window.addEventListener('error', (event) => {
  if (event.message?.includes('cross-origin') || 
      event.filename?.includes('posthog')) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Unhandled rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason?.message?.includes('cross-origin') ||
      event.reason?.stack?.includes('posthog')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
